import React from 'react';
import {
    Box,
    FormControl,
    FormGroup,
    ListItemText,
    MenuItem
} from '@mui/material';
import { ArrowLeftLinearIcon } from '../../../icons-lib';
import i18n from '../../../i18';
import Scrollbar from '../../../components/scrollbar/Scrollbar';
import CheckboxRound from '../../../components/round-checkbox';
import { getFilterField } from '../../../utils/formatName';

export const FilterBoolean = ({
    filters,
    selectedFilter,
    field,
    onValueChange,
    onBack
}) => {

    const options = [
        { label: field.trueLabel, value: true },
        { label: field.falseLabel, value: false }
    ];

    const selectedValue = filters.find(
        (f) =>
            f.field ===
            getFilterField(selectedFilter)
    )?.value;

    const handleOptionChange = (value) => {
        onValueChange(value);
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <MenuItem onClick={onBack}>
                <ArrowLeftLinearIcon sx={{ mr: 2 }} />
                {i18n.t(`columns.${field.label}`)}
            </MenuItem>
            <FormControl>
                <FormGroup>
                    <Scrollbar sx={{ maxHeight: 300 }}>
                        {options.map((option) => {
                            return (
                                <MenuItem
                                    key={option.value}
                                    onClick={() =>
                                        handleOptionChange(option.value)
                                    }
                                    sx={{
                                        '&.Mui-selected': {
                                            backgroundColor: (theme) =>
                                                theme.palette.action
                                                    .mainSelected
                                        }
                                    }}
                                >
                                    <CheckboxRound
                                        checked={selectedValue === option.value}
                                    />
                                    <ListItemText
                                        primary={i18n.t(
                                            `enums.${option.label}`
                                        )}
                                        sx={{ ml: 1 }}
                                    />
                                </MenuItem>
                            );
                        })}
                    </Scrollbar>
                </FormGroup>
            </FormControl>
        </Box>
    );
};
